import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class CartPage extends Component {

	componentDidMount() {

     const $ = window.$;

     $( 'body' ).addClass( 'bg-gray' );

 	}

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'

    return <div className="signin-page-area pd-top-50 pd-bottom-100 ">
			  <div className="container">
			    <div className="row justify-content-center">
			    	<div className="col-xl-7 col-lg-7">
						<div className="cart-header">
							<div className="cart-total"><i className="fas fa-shopping-basket"></i><span>Your item (5)</span></div>
						</div>
						<ul className="cart-list">
							<li className="cart-item">
								<div className="cart-media">
									<Link to="#"><img src={publicUrl+"assets/img/b1.jpg"} alt="product"/></Link>
									<button className="cart-delete"><i className="far fa-trash-alt"></i></button>
								</div>
								<div className="cart-info-group">
									<div className="cart-info">
									<h6><Link to="#">existing product name</Link></h6>
									<p>Unit Price - $8.75</p>
									</div>
									<div className="cart-action-group">
										<div className="product-action">
											<button className="action-minus" title="Quantity Minus" fdprocessedid="lvxkej"><i class="fa-solid fa-minus"></i></button>
											<input className="action-input" title="Quantity Number" type="text" name="quantity" value="1" fdprocessedid="29odk8"/>
											<button className="action-plus" title="Quantity Plus" fdprocessedid="z4ywhf"><i class="fa-solid fa-plus"></i></button>
										</div>
									<h6>$56.98</h6>
									</div>
								</div>
							</li>
							<li className="cart-item">
								<div className="cart-media">
									<Link to="#"><img src={publicUrl+"assets/img/b2.jpg"} alt="product"/></Link>
									<button className="cart-delete"><i className="far fa-trash-alt"></i></button>
								</div>
								<div className="cart-info-group">
									<div className="cart-info">
									<h6><Link to="#">existing product name</Link></h6>
									<p>Unit Price - $8.75</p>
									</div>
									<div className="cart-action-group">
										<div className="product-action">
											<button className="action-minus" title="Quantity Minus" fdprocessedid="lvxkej"><i class="fa-solid fa-minus"></i></button>
											<input className="action-input" title="Quantity Number" type="text" name="quantity" value="1" fdprocessedid="29odk8"/>
											<button className="action-plus" title="Quantity Plus" fdprocessedid="z4ywhf"><i class="fa-solid fa-plus"></i></button>
										</div>
									<h6>$56.98</h6>
									</div>
								</div>
							</li>
							<li className="cart-item">
								<div className="cart-media">
									<Link to="#"><img src={publicUrl+"assets/img/b1.jpg"} alt="product"/></Link>
									<button className="cart-delete"><i className="far fa-trash-alt"></i></button>
								</div>
								<div className="cart-info-group">
									<div className="cart-info">
									<h6><Link to="#">existing product name</Link></h6>
									<p>Unit Price - $8.75</p>
									</div>
									<div className="cart-action-group">
										<div className="product-action">
											<button className="action-minus" title="Quantity Minus" fdprocessedid="lvxkej"><i class="fa-solid fa-minus"></i></button>
											<input className="action-input" title="Quantity Number" type="text" name="quantity" value="1" fdprocessedid="29odk8"/>
											<button className="action-plus" title="Quantity Plus" fdprocessedid="z4ywhf"><i class="fa-solid fa-plus"></i></button>
										</div>
									<h6>$56.98</h6>
									</div>
								</div>
							</li>						
						</ul>
						<div className="cart-footer">
							<div class="price-text">
								<div class="left-text">Price (3 items)</div>
								<div class="right-text">₹27,071.00</div>
							</div>
							<div class="price-text discount-price">
								<div class="left-text">Discount</div>
								<div class="right-text">- ₹2,708.00</div>
							</div>
							<div class="price-text discount-price"></div>
							<div class="price-text total-amount">
								<div class="left-text">
									Total amount 
									<div class="small-text">ALV (14% included): 4.63 €</div>
								</div>
								<div class="right-text">₹24,363.00</div>
							</div>
							<a className="cart-checkout-btn" href="#"><span className="checkout-label">Proceed to Checkout</span><span className="checkout-price">$369.78</span></a>
						</div>
			      	</div>
					<div className="col-xl-5 col-lg-5">						
						<div className="card p-3">
							<div className="cart-header">
								<div className="cart-total"><span>Order Info</span></div>
							</div>
							<p className="new-note">Note: Once order is placed cannot be cancelled</p>							
							<h6 class="bhu">
								Order Type :- <br/><button type="button" class="btn-lg btn-toggler" data-toggle="button" aria-pressed="false" autocomplete="off">
								<div class="handle"></div></button>
							</h6>
							<h6 class="bhu">
								If You have :- <br/>
								<div class="custom-control custom-radio custom-control-inline">
									<input type="radio" id="customRadioInline1" name="customRadioInline1" class="custom-control-input"/>
									<label class="custom-control-label" for="customRadioInline1">Coupon Code</label>
								</div>
								<div class="custom-control custom-radio custom-control-inline">
									<input type="radio" id="customRadioInline2" name="customRadioInline1" class="custom-control-input"/>
									<label class="custom-control-label" for="customRadioInline2">Gift Card</label>
								</div>
							</h6>
							<div className="col-xl-12 col-lg-6 mb-3">
								<div class="input-group">
									<input class="form-control py-2 border-right-0 border" type="text" placeholder="Enter Coupon Code"/>
									<span class="input-group-append">
										<button class="btn-outline-secondary border-left-0 border" type="button">
											<i class="p-2 text-pri fa-sharp fa-solid fa-badge-check"></i>
										</button>
									</span>
								</div>
							</div>
							<h6 class="bhu">
								<div class="custom-control custom-radio custom-control-inline">
									<input type="radio" id="customRadioInline3" name="customRadioInline2" class="custom-control-input"/>
									<label class="custom-control-label" for="customRadioInline3">Pay</label>
								</div>
								<div class="custom-control custom-radio custom-control-inline">
									<input type="radio" id="customRadioInline4" name="customRadioInline2" class="custom-control-input"/>
									<label class="custom-control-label" for="customRadioInline4">Pay Online</label>
								</div>
							</h6>
							<div className="col-xl-12">
								<label className="single-input-inner style-bg-border">
									<textarea placeholder="Your Message to Kitchen" defaultValue={""} />
								</label>
							</div>
							<div className="col-xl-12 mb-3">
								<div class="input-group mb-2">
									<div class="input-group-prepend">
									<div class="input-group-text">+358</div>
									</div>
									<input type="text" class="form-control" id="inlineFormInputGroup" placeholder="Enter Contact No"/>
								</div>
							</div>
							<a className="cart-checkout-btn text-white" data-toggle="modal" data-target="#exampleModalCenter1">Schedule Your Order For Later Pickup</a>
						
						</div>
					</div>
			    </div>
			  </div>
			  <div class="modal fade" id="exampleModalCenter1" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenter1Title" aria-hidden="true">
					<div class="modal-dialog modal-md modal-dialog-centered" role="document">
					<div class="modal-content">
						<div class="modal-header">
						<h6 class="modal-title" id="exampleModalLongTitle">SCHEDULE YOUR ORDER <small>(No money charged on this steps)</small></h6>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
						</div>
						<div class="modal-body">
							<p><small className="text-success">Scheduled Delivery allows you to choose a date and time convenient to you for delivery</small></p>
							<p><strong className='text-danger'>Today our resturant will be open between 10:30 am and 08:30 pm, You can scheduled your order by filling above form.</strong></p>
							<div class="row mb-2">
								<div className="col-md-6">
									<p className="mb-0"><strong>Date</strong></p>
									<label className="single-input-inner style-bg-border">
										<input type="date" placeholder="date" />
									</label>
								</div>
								<div className="col-md-6">
									<p className="mb-0"><strong>Time</strong></p>
									<label className="single-input-inner style-bg-border">
										<input type="time" placeholder="time" />
									</label>
								</div>
							</div>	
							<div className="mb-3 text-center">
								<h6 className="text-dark">Restaurant Hours</h6>
							</div>
							<div className="container text-center">
								<div className="row">
									<div className="col-md-6">
										<p className="text-left">
											Monday : 10:30 - 22:00 
										</p>
									</div>
									<div className="col-md-6">
										<p className="text-left">
											Tuesday : 10:30 - 22:00 
										</p>
									</div>
									<div className="col-md-6">
										<p className="text-left">
											Wednesday : 10:30 - 22:00     
										</p>
									</div>
									<div className="col-md-6">
										<p className="text-left">
											Thursday : 10:30 - 22:00 
										</p>
									</div>
									<div className="col-md-6">
										<p className="text-left">
											Friday : 10:30 - 22:00 
										</p>
									</div>
									<div className="col-md-6">
										<p className="text-left">
											Saturday : 12:00 - 22:00 
										</p>
									</div>
									<div className="col-md-6">
										<p className="text-left">
											Sunday :  Closed
										</p>
									</div>
								</div>
							</div>						
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-base btn-xs">Schedule</button>
						</div>
					</div>
					</div>
				</div>
			</div>
        }
}

export default CartPage